const formatEntries = artwork => {
  let urlPreview;
  let entryUrl;
  if (artwork.primaryImageSmall) {
    urlPreview = artwork.primaryImageSmall;
    entryUrl = artwork.primaryImageSmall;
    if (artwork.museum === "met") {
      entryUrl = artwork.primaryImageSmall;
    }
  }

  return {
    ...artwork,
    attributions: {
      creator: {
        name: artwork.artistDisplayName ?? ""
      }
    },
    author: artwork.artistDisplayName ?? "",
    artworkDate: artwork.objectDate,
    collection: artwork.department,
    id: artwork.objectID,
    isCommunityMedia: true,
    thumbnail: urlPreview,
    images: {
      preview: {
        url: urlPreview
      }
    },
    public_thumbnail: urlPreview,
    title: artwork.title ?? artwork.name,
    name: artwork.title ?? artwork.name,
    type: "artwork",
    artwork: {
      artist: artwork.artistDisplayName ?? "",
      author: artwork.artistDisplayName ?? "",
      dimensions: artwork.dimensions,
      category: artwork.department,
      museum: artwork.museum,
      title: artwork.title ?? artwork.name,
      medium: artwork.medium
    },
    url: entryUrl
  };
};

const formatResponse = ({ data, meta, filterItems }) => {
  // Format and filter entries
  const entries = data
    .map(artwork => formatEntries(artwork))
    .filter((artwork, index, self) => index === self.findIndex(t => t.id === artwork.id));

  const { pagination } = meta;

  const totalPages = Math.ceil(pagination.total / pagination.perPage);

  // Determine next and previous pages
  meta.next_page = pagination.currentPage < totalPages ? pagination.currentPage + 1 : null;
  meta.prev_page = pagination.currentPage > 1 ? pagination.currentPage - 1 : null;

  return { entries, meta, filterItems };
};

const DEFAULT_PAGE = 1;
export const PER_PAGE = 12;
let publicArtApi = "";
let ngaCollectionsCache = null;
let metCollectionsCache = null;

export const MUSEUMS = {
  nga: {
    id: "nga",
    name: "National Gallery of Art"
  },
  met: {
    id: "met",
    name: "The Metropolitan Museum of Art"
  }
};

export function setPublicArtApi(api) {
  publicArtApi = api;
}

const fetchNgaArtWorks = async ({ collection, page = DEFAULT_PAGE, query, signal }) => {
  let allArtworksUrl = `${publicArtApi}/nga?page=${page}&perPage=${PER_PAGE}`;

  if (query) {
    allArtworksUrl += `&q=${encodeURIComponent(query)}`;
  }

  if (collection && collection !== "") {
    allArtworksUrl += `&department=${encodeURIComponent(collection)}`;
  }

  const response = await fetch(allArtworksUrl, { signal });

  const { data, meta: apiMeta } = await response.json();

  const meta = {
    pagination: {
      count: (page - 1) * PER_PAGE + data.length,
      total: apiMeta?.total,
      perPage: PER_PAGE,
      currentPage: page
    }
  };

  return { data, meta, url: allArtworksUrl };
};

const fetchMetArtworks = async ({ collection, page = DEFAULT_PAGE, query, signal }) => {
  let allArtworksUrl = `${publicArtApi}/met?page=${page}&perPage=${PER_PAGE}`;

  if (query) {
    allArtworksUrl += `&q=${encodeURIComponent(query)}`;
  }

  if (collection && collection !== "") {
    allArtworksUrl += `&department=${encodeURIComponent(collection)}`;
  }

  const response = await fetch(allArtworksUrl, { signal });

  const { data, meta: apiMeta } = await response.json();

  const meta = {
    pagination: {
      count: (page - 1) * PER_PAGE + data.length,
      total: apiMeta?.total,
      perPage: PER_PAGE,
      currentPage: page
    }
  };
  return { data, meta, url: allArtworksUrl };
};

export async function fetchNgaCollections(signal) {
  // Return cached data if available
  if (ngaCollectionsCache) {
    return ngaCollectionsCache;
  }

  const departmentsUrl = `${publicArtApi}/nga/departments`;
  const response = await fetch(departmentsUrl, { signal });
  const { data } = await response.json();

  // Cache the data for future calls
  ngaCollectionsCache = data;

  return data;
}

export async function fetchMetCollections(signal) {
  // Return cached data if available
  if (metCollectionsCache) {
    return metCollectionsCache;
  }

  let departmentsUrl = `${publicArtApi}/met/deparments`; // Corrected typo from 'deparments' to 'departments'

  const response = await fetch(departmentsUrl, { signal });
  const { data } = await response.json();

  // Cache the data for future calls
  metCollectionsCache = data;

  return data;
}

const queryNga = async (dropdownFilter, page, query, signal) => {
  const filterItems = await fetchNgaCollections(signal);

  const collection = dropdownFilter ? dropdownFilter : filterItems[0]?.id;

  const { data, meta, url } = await fetchNgaArtWorks({
    page,
    collection,
    query,
    signal
  });

  const formattedData = data.map(entry => ({
    ...entry,
    museum: MUSEUMS.nga.id
  }));

  const result = formatResponse({
    data: formattedData,
    meta,
    filterItems
  });

  return [url, result];
};

const queryMet = async (dropdownFilter, page, query, signal) => {
  const { data, meta, url } = await fetchMetArtworks({
    page,
    collection: dropdownFilter,
    query,
    signal
  });

  const formattedData = data.map(entry => ({
    ...entry,
    museum: MUSEUMS.met.id
  }));

  const filterItems = await fetchMetCollections(signal);

  const result = formatResponse({ data: formattedData, meta, filterItems });
  return [url, result];
};

export function queryArt(filter = "", dropdownFilter = null, page = DEFAULT_PAGE, query = "", signal = null) {
  switch (filter) {
    // case 'placeart-artists':
    //   return queryArtists(dropdownFilter, page, query);
    case "met":
      return queryMet(dropdownFilter, page, query, signal);
    default:
      return queryNga(dropdownFilter, page, query, signal);
  }
}
